module.exports = __webpack_public_path__ + "img/ent3.b9c03559.png";